import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource, invalidateResource  } from "kea-resource";

import { StatusCamionViewDtoListMem } from "./listmem";
interface Props {
    value: models.FiltroStatusCamion;
}

export class StatusCamionList extends React.PureComponent<Props> {
    value = (props: Props) => props.value;
    items = createSelectorRx(this.value, value => observeResource(resources.Camion.ConsultarStatus, value));

    onRefrescar = () => {
        invalidateResource(resources.CajaRuta);
    }
    render() {
        const items = this.items(this.props);
        return <StatusCamionViewDtoListMem value={items} onRefrescar={this.onRefrescar } />;
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/movimientoscamion/list/list.tsx